import React, { PropsWithChildren } from 'react';
import cx from 'classnames';
import AsignaLogo from 'images/asigna-logo.svg';
import { useAppsIframe } from 'store';

import { ConnectWalletButton } from '../ConnectWalletButton';

import burgerIcon from './util/images/burger.svg';

type Props = {
  isSidebarDisplayed: boolean;
  isMobileMenuOpen?: boolean;
  isMobile?: boolean;
  handleMobileMenuOpen: (value: boolean) => void;
};

export const SidebarWrapper: React.FC<PropsWithChildren<Props>> = ({
  children,
  isSidebarDisplayed,
  isMobileMenuOpen = false,
  isMobile = false,
  handleMobileMenuOpen,
}) => {
  const { isIframeRun, setSidebarHidden } = useAppsIframe();

  if (!isSidebarDisplayed)
    return (
      <div className="flex w-full items-center justify-between px-20 sm:px-24 h-40 gap-16 z-30 mt-16">
        <a href="/" className="flex">
          <img src={AsignaLogo} width={80} height={30} alt="asigna" />
        </a>
        <ConnectWalletButton />
      </div>
    );

  return (
    <>
      {isMobile ? (
        <div
          className={cx(
            'flex w-full items-center justify-between px-20 sm:px-24 h-40 gap-16 z-50',
            isIframeRun ? 'mt-0' : 'mt-16'
          )}
        >
          {!isIframeRun && (
            <>
              <a href="/" className="flex">
                <img src={AsignaLogo} width={80} height={30} alt="asigna" />
              </a>
              <ConnectWalletButton />
              {isSidebarDisplayed && (
                <button
                  className="flex sm:hidden ml-auto"
                  onClick={() => handleMobileMenuOpen(true)}
                >
                  <img src={burgerIcon} width={24} height={24} alt="burger menu" />
                </button>
              )}
            </>
          )}
          {isMobileMenuOpen && (
            <div
              className="fixed inset-0 z-10 bg-black-0 opacity-70"
              onClick={() => {
                handleMobileMenuOpen(false);
                if (isIframeRun) {
                  setSidebarHidden(true);
                }
              }}
            />
          )}
          <div
            className="absolute left-0 top-0 z-50 bg-black-0 border-r-[.5px] border-black-4"
            style={{
              left: isMobileMenuOpen ? '0' : '-92vw',
              zIndex: isMobileMenuOpen ? 50 : 0,
              transition: 'left 0.4s ease-in-out',
            }}
          >
            {children}
          </div>
        </div>
      ) : (
        <>{children}</>
      )}
    </>
  );
};
